import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation, type NavigationProp } from "@react-navigation/native";
import {
  QuestionLayout,
  SquareOptionButton,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useFamilyHistory } from "../FamilyHistoryContext";
import type { FamilyHistoryStackParamList } from "../FamilyHistoryNavigator";
import { ADOPTION_OPTIONS, type AdoptionStatusEnum } from "../options";

export function AdoptedScreen() {
  const t = useTranslations();
  const { state, updateState } = useFamilyHistory();
  const navigation =
    useNavigation<NavigationProp<FamilyHistoryStackParamList>>();

  const handleSelect = (value: AdoptionStatusEnum) => {
    updateState({ adoptionStatus: value });
  };

  const handleNext = () => {
    if (
      state.adoptionStatus === "adopted_or_dont_know_biological_parents" ||
      state.adoptionStatus === "from_gamete_donation"
    ) {
      // Skip family questions — go straight to complete
      navigation.navigate("FamilyHistoryComplete");
    } else {
      navigation.navigate("FamilyInfertility");
    }
  };

  return (
    <QuestionLayout
      title={t("med_history.family_history.adopted_title")}
      subtitle={t("med_history.family_history.adopted_subtitle")}
      onBack={() => navigation.goBack()}
      onSave={handleNext}
      saveDisabled={state.adoptionStatus === null}
      saveLabel={t("med_history.shared.next")}
    >
      <View style={styles.grid}>
        {ADOPTION_OPTIONS.map((option) => (
          <View
            key={option.id}
            style={option.id === "not_adopted" ? styles.fullWidth : styles.cell}
          >
            <SquareOptionButton
              icon={option.icon}
              label={t(option.labelKey)}
              isSelected={state.adoptionStatus === option.id}
              onPress={() => handleSelect(option.id)}
              labelSize="sm"
            />
          </View>
        ))}
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
    width: "100%",
    marginBottom: 40,
  },
  cell: {
    width: "47%",
  },
  fullWidth: {
    width: "100%",
  },
});
